import { useQuery } from '@tanstack/react-query';

import { partnersApi, partnersApiKeys } from '@/api/routes/partners/partners.api';

/** The account timeline for the Conta page (P15), newest first. */
export const usePartnersReadAccountHistory = () => {
  return useQuery({
    queryKey: partnersApiKeys.history(),
    queryFn: () => partnersApi.history().then((res) => res.data.items),
  });
};
